import React, { useEffect, useState } from 'react';
import { CharacterModel } from '../../interfaces/character.interface';
import Loader from '../Common/Loader';
import { getAdminUserCharacters } from '../../services/AdminUser.service';
import AdminCharacterGrid from './AdminCharacterGrid';

interface AdminCharactersTabProps {
  email?: string;
  active: boolean;
  refreshKey?: number;
}

const AdminCharactersTab: React.FC<AdminCharactersTabProps> = ({ email, active, refreshKey }) => {
  const [characters, setCharacters] = useState<CharacterModel[]>([]);
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    setFetched(false);
  }, [refreshKey]);

  useEffect(() => {
    if (!active || !email || fetched) return;
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const data = await getAdminUserCharacters(email);
        if (!cancelled) {
          setCharacters(data);
          setFetched(true);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [active, email, fetched]);

  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <Loader loader={loading} dimentions={'w-8 h-8'} />
      </div>
    );
  }

  return <AdminCharacterGrid characters={characters} />;
};

export default AdminCharactersTab;
